<template>
  <div class="manual">
    <div class="itemArea row p-4">
      <div class="itemHeader">Description</div>
      <div id="appLocalizedData" class="itemBody">
        {{ this.appInfoData.description.replace(new RegExp(/. ●+/g), "\n●") }}
      </div>
    </div>
    <div class="itemArea row">
      <div class="itemHeader">Additional information</div>
      <div class="itemBody">
        <div class="d-flex row justify-content-between" id="ie">
          <div class="offer col-1 col-md-2">
            <div>Offered By</div>
            <div id="vendorName" style="white-space: nowrap">
              {{ appInfoData.vendorName }}
            </div>
          </div>
          <div class="supported col-0 ml-2 col-md-2">
            <div>Languages supported</div>
            <div id="supportLanguages">
              {{ getSupportLanguagesText }}
              <span
                id="toggleOpenAppSupportLanguagesButton"
                class="more"
                ref="more"
                v-if="isMoreSupportLanguages"
                @click="toggleHandler()"
              >
                More
              </span>
            </div>
            <div class="dropdownContent" :class="{ show: this.showDropdown }">
              <div class="languageContent">
                <a>
                  <img
                    @click="toggleHandler()"
                    class="imgg"
                    id="closeTb"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4wgeFzIsGnMlhgAAAQVJREFUKM+N0bEug2EUxvFfm+86uAGjwWSSGIwYNBFtVSMRsbsGaRjQVNNqSzuUG5CwiCswWCwWl4HlNPk0X/nOcvKec/7PeXLeQqlUmsccnuWPZbwXsYhHrOcEt2N+oYh7HGOEjRxgB0d4SKJ4gq8QgLsMcAdtHKIJSarZiDxCAeNUr4wrHKA1KSZT6o1wMIz3GJUAfoFZMJziOwRWsIv9sOw/GM6whHrYbWcNFWfAVWzG9gq2soayNtdwiT108YJ+HHH4FzwBa+hF7SJyLwRus+A6zuNA/SnRi/iF6xC4ScMTsIrBjDs0Q6AbAoMEawGW05ZmxOSfO/hM8IpVPMkXLXzg7Qdx7Tnt9QCoPgAAAABJRU5ErkJggg=="
                  />
                </a>
                <span
                  v-for="(language, index) in supportLanguageList"
                  v-bind:key="language">
                  {{ language }}<span v-if="index < supportLanguageList.length - 1">,</span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-0 ml-2 col-md-auto ml-md-1 platformType">
            <div>Platform type</div>
            <div id="platformType" class="platformType">
              {{ appInfoData.platformType }}
            </div>
          </div>
          <div
            class="col ml-4 ml-md-1 col-md-auto currentVersion"
            id="version-ie"
          >
            <div>Current version</div>
            <div class="version">{{ appInfoData.version }}</div>
          </div>
          <div class="supported col-0 ml-2 col-md-2 countryAvailability">
            <div>Country availability</div>
            <div class="countryavailability">
              <div>
                {{ getSupportCountryCount }}
                <span
                  class="country"
                  v-if="isMoreSupportCountryList"
                  @click="toggle()"
                >
                  More
                </span>
              </div>
              <div class="dropdownContent" :class="{ show: this.isShow }">
                <div class="countryContent">
                  <a>
                    <img
                      @click="toggle()"
                      class="imggCountry"
                      id="closeTb"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4wgeFzIsGnMlhgAAAQVJREFUKM+N0bEug2EUxvFfm+86uAGjwWSSGIwYNBFtVSMRsbsGaRjQVNNqSzuUG5CwiCswWCwWl4HlNPk0X/nOcvKec/7PeXLeQqlUmsccnuWPZbwXsYhHrOcEt2N+oYh7HGOEjRxgB0d4SKJ4gq8QgLsMcAdtHKIJSarZiDxCAeNUr4wrHKA1KSZT6o1wMIz3GJUAfoFZMJziOwRWsIv9sOw/GM6whHrYbWcNFWfAVWzG9gq2soayNtdwiT108YJ+HHH4FzwBa+hF7SJyLwRus+A6zuNA/SnRi/iF6xC4ScMTsIrBjDs0Q6AbAoMEawGW05ZmxOSfO/hM8IpVPMkXLXzg7Qdx7Tnt9QCoPgAAAABJRU5ErkJggg=="
                    />
                  </a>
                  <span
                    v-for="(countryList, index) in supportCountryList"
                    v-bind:key="countryList">
                    {{ countryList }}<span v-if="index < supportCountryList.length - 1">,</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="itemArea row">
      <div class="itemBody">
        <div
          class="site"
          v-if="
            this.appInfoData.webSite !== '' &&
            this.appInfoData.webSite !== null &&
            this.appInfoData.contactEmail !== null &&
            this.appInfoData.contactEmail !== ''
          "
        >
          <div class="itemHeader">Support</div>
          <div>Website</div>
          <div>
            <a
              id="moveToAppWebsiteLinkButton"
              class="blueText"
              :href="appInfoData.webSite"
              target="_blank"
            >
              Visit support website
            </a>
          </div>
          <div class="email">
            <div>Email</div>
            <div class="blueText">{{ appInfoData.contactEmail }}</div>
          </div>
        </div>
        <div
          class="email"
          v-else-if="
            this.appInfoData.contactEmail !== null &&
            this.appInfoData.contactEmail !== ''
          "
        >
          <div class="itemHeader">Support</div>
          <div>Email</div>
          <div class="blueText">{{ appInfoData.contactEmail }}</div>
        </div>
      </div>
    </div>

    <div class="itemArea row">
      <div
        class="itemHeader"
        v-if="
          this.appInfoData.dataPolicy != null &&
          this.appInfoData.privacyStatment != null
        "
      >
        Disclaimer
      </div>
      <div
        id="appLocalizedData"
        class="itemBody"
        v-if="
          this.appInfoData.dataPolicy != null &&
          this.appInfoData.privacyStatment != null &&
          this.appInfoData.name == 'HP Mail Flow'
        "
      >
        HP Mail Flow app’s use and transfer to any other app of information
        received from Google APIs will adhere to
        <a :href="appInfoData.dataPolicy">
          <u>Google API Services User Data Policy</u></a
        >, including the Limited Use requirements. HP will handle your data in
        accordance with our
        <a :href="appInfoData.privacyStatment"><u>Privacy Statement</u></a
        >.
      </div>

      <div
        id="appLocalizedData"
        class="itemBody"
        v-if="
          this.appInfoData.dataPolicy != null &&
          this.appInfoData.privacyStatment != null &&
          this.appInfoData.name == 'HP for Google Drive'
        "
      >
        HP for Google Drive app’s use and transfer to any other app of
        information received from Google APIs will adhere to
        <a :href="appInfoData.dataPolicy">
          <u>Google API Services User Data Policy</u></a
        >, including the Limited Use requirements. HP will handle your data in
        accordance with our
        <a :href="appInfoData.privacyStatment"><u>Privacy Statement</u></a
        >.
      </div>

      <div
        id="appLocalizedData"
        class="itemBody"
        v-if="
          this.appInfoData.dataPolicy != null &&
          this.appInfoData.privacyStatment != null &&
          this.appInfoData.name == 'HP for Google Drive (Special Edition)'
        "
      >
        HP for Google Drive (Special Edition) app’s use and transfer to any
        other app of information received from Google APIs will adhere to
        <a :href="appInfoData.dataPolicy">
          <u>Google API Services User Data Policy</u></a
        >, including the Limited Use requirements. HP will handle your data in
        accordance with our
        <a :href="appInfoData.privacyStatment"><u>Privacy Statement</u></a
        >.
      </div>

      <div
        id="appLocalizedData"
        class="itemBody"
        v-if="
          this.appInfoData.dataPolicy != null &&
          this.appInfoData.privacyStatment != null &&
          this.appInfoData.name == 'HP Mail Flow Lite'
        "
      >
        HP Mail Flow Lite app’s use and transfer to any other app of information
        received from Google APIs will adhere to
        <a :href="appInfoData.dataPolicy">
          <u>Google API Services User Data Policy</u></a
        >, including the Limited Use requirements. HP will handle your data in
        accordance with our
        <a :href="appInfoData.privacyStatment"><u>Privacy Statement</u></a
        >.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "manual",
  props: {
    appInfoData: { type: Object, default: () => ({}) },
    supportLanguageList: { type: Array, default: () => [] },
    supportCountryList: { type: Array, default: () => [] },
    uuid: String,
  },
  data() {
    return {
      showDropdown: false,
      isRenderContent: false,
      spinner: 0,
      isShow: false,
    };
  },
  computed: {
    getSupportLanguagesText() {
      return this.isMoreSupportLanguages
        ? `${this.getDefaultSupportLanguages} & ${
            this.supportLanguageList.length - 1
          }`
        : `${this.getDefaultSupportLanguages}`;
    },
    getDefaultSupportLanguages() {
      return typeof this.supportLanguageList[0] !== "undefined"
        ? this.supportLanguageList[0]
        : "";
    },
    isMoreSupportLanguages() {
      return this.supportLanguageList.length > 1;
    },
    getSupportCountryCount() {
      return this.isMoreSupportCountryList
        ? `${this.getDefaultCountryList} & ${
            this.supportCountryList.length - 1
          }`
        : `${this.getDefaultCountryList}`;
    },
    getDefaultCountryList() {
      return this.supportCountryList[0];
    },
    isMoreSupportCountryList() {
      return this.supportCountryList.length > 1;
    },
    appLocalizedData() {
      return this.appInfoData.description;
    },
  },
  methods: {
    toggleHandler() {
      this.showDropdown = !this.showDropdown;
    },
    toggle() {
      this.isShow = !this.isShow;
    },
    close(event) {
      if (
        this.isMoreSupportLanguages &&
        !this.$refs.more.contains(event.target)
      ) {
        this.showDropdown = false;
      }
    },
    hide(event) {
      if (
        this.isMoreSupportCountryList &&
        !this.$refs.more.contains(event.target)
      ) {
        this.isShow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/hpConstant.scss";
@import "../../styles/hpMixin.scss";
@import "../../styles/hpCustom.scss";
@mixin contentArea($minWidth, $maxWidth) {
  min-width: $minWidth;
  max-width: $maxWidth;
}

.manual {
  font-family: "FormaDJR";
  margin-bottom: 5%;
  width: 100%;
  flex-direction: column;
  .itemArea {
    padding-top: 2%;
    padding-left: 2%;
    padding-right: 2%;
    width: 100%;
    .itemHeader {
      margin-bottom: 1rem;
      padding-bottom: 1rem;
      color: $hpDeepGray;
      font-size: 1.6rem;
      text-align: left;
      border-bottom: 1px solid lightgray;
      width: 100%;
      float: left;
      .site {
        float: left;
      }
    }
    .itemBody {
      line-height: 1.3rem;
      color: $hpBlack;
      font-size: 1rem;
      text-align: justify;
      width: 100%;
      .platformType {
        margin-right: 29px;
      }
      .offer,
      .site,
      .developer,
      .platform,
      .supported,
      .currentVersion {
        margin-right: 45px;

        .viewDetail {
          color: $hpLightBlue;
          cursor: pointer;
          text-decoration: underline;
        }
        .more {
          margin-left: 10px;
          text-decoration: underline;
          color: $hpLightBlue;
          cursor: pointer;
        }
        .country {
          text-decoration: underline;
          color: $hpLightBlue;
          cursor: pointer;
        }
        .imgg {
          padding: 0 0 0 165px;
        }
        .imggCountry {
          padding: 0 0 0 275px;
        }

        .blueText {
          color: $hpLightBlue;
          cursor: pointer;
          text-decoration: underline;
        }
        .dropdownContent {
          @include hpDropdownSpeechBubble(200px, 90px, 15px);
          .languageContent {
            display: flex;
            flex-wrap: wrap;
            margin: 5px 0 0 5px;
            max-width: 255px;
            span {
              margin: 0 1px;
            }
          }
        }
        .dropdownContent {
          @include hpDropdownSpeechBubble(200px, 90px, 15px);
          .countryContent {
            display: flex;
            width: 300px;
            flex-wrap: wrap;
            margin: 5px 0 0 5px;
            span {
              margin: 0 1px;
            }
          }
        }
        .dropdownContent:after {
          @include hpDropdownSpeechBubbleAfter(112px);
        }
        .dropdownContent:before {
          @include hpDropdownSpeechBubbleBefore(112px);
        }
        .show {
          display: block;
        }
        .version {
          display: inline-block;
        }
      }
    }
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  img {
    width: 65%;
    margin: 0 0 0 12%;
  }
}
</style>